import { combineReducers } from 'redux';
import encargado_recupero from './encargado-recupero-reducer';
import recupero_cias from './recupero-cias-reducer';

const appReducers = combineReducers({
    encargado_recupero,
    recupero_cias
})

export default appReducers;